import { cloneDeep } from 'lodash';
const SET_GENRES = 'SET_GENRES';

const initialState = [];

export default function reducer(state = cloneDeep(initialState), action) {
	switch (action.type) {
		case SET_GENRES:
			return action.payload;
		default:
			return state;
	}
}

export function setGenres( genres=[] ){
	return{
		type: SET_GENRES,
		payload: genres
	}
}



// WEBPACK FOOTER //
// ./src/modules/genres.js